
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './translations/en.json';
import no from './translations/no.json';
import de from './translations/de.json';
import pl from './translations/pl.json';
import es from './translations/es.json';
import fr from './translations/fr.json';
import nl from './translations/nl.json';
import sv from './translations/sv.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        detection: {
            // Normalize Norwegian Bokmål (nb) and Nynorsk (nn) to 'no' so all
            // startsWith('no') checks in the app work for real Norwegian browsers.
            convertDetectedLanguage: (lng: string) => {
                if (lng.startsWith('nb') || lng.startsWith('nn')) return 'no';
                return lng;
            }
        },
        debug: false,
        resources: {
            en: { translation: en },
            no: { translation: no },
            de: { translation: de },
            pl: { translation: pl },
            es: { translation: es },
            fr: { translation: fr },
            nl: { translation: nl },
            sv: { translation: sv }
        },
        supportedLngs: ['en', 'no', 'de', 'pl', 'es', 'fr', 'nl', 'sv'],
        nonExplicitSupportedLngs: false,
        load: 'languageOnly',
        fallbackLng: 'no',
        interpolation: {
            escapeValue: false
        }
    });

// Keep <html lang> in sync with i18n for SEO/accessibility.
if (typeof document !== 'undefined') {
    document.documentElement.lang = i18n.language || 'no';
    i18n.on('languageChanged', (lng) => {
        document.documentElement.lang = lng;
    });
}

export default i18n;
